module.exports = __webpack_public_path__ + "img/ex_straightFlush.353f9083.png";